'use es6';

import { useContext } from 'react';
import isLegacyHubSpotObject from 'customer-data-objects/crmObject/isLegacyHubSpotObject';
import CrmObjectActionsDropdown from './CrmObjectActionsDropdown';
import styled from 'styled-components';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { PermissionsContext } from '../context/PermissionsContext';
import { SidebarSubjectContext } from '../context/SidebarSubjectContext';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledHighlight = styled.div.withConfig({
  displayName: "UniversalSidebarHighlight__StyledHighlight",
  componentId: "sc-1vpczll-0"
})(["border-bottom:1px solid ", ";padding:24px;"], BATTLESHIP);
const Title = styled.h2.withConfig({
  displayName: "UniversalSidebarHighlight__Title",
  componentId: "sc-1vpczll-1"
})(["padding:4px 16px;&&{margin-bottom:4px;}"]);
const UniversalSidebarHighlight = ({
  objectId,
  objectType
}) => {
  const {
    canDeleteSubject,
    readOnly
  } = useContext(PermissionsContext);
  const {
    primaryDisplayLabel
  } = useContext(SidebarSubjectContext);
  const isCrmObject = !isLegacyHubSpotObject(objectType);
  const renderActions = () => {
    if (isCrmObject && canDeleteSubject && !readOnly) {
      return /*#__PURE__*/_jsx(CrmObjectActionsDropdown, {
        objectTypeId: objectType,
        objectId: objectId
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(StyledHighlight, {
    "data-selenium-test": "universal-sidebar-highlight",
    children: [renderActions(), /*#__PURE__*/_jsx(Title, {
      className: "text-left",
      children: primaryDisplayLabel
    })]
  });
};
UniversalSidebarHighlight.propTypes = {
  objectId: PropTypes.string.isRequired,
  objectType: PropTypes.string.isRequired
};
export default UniversalSidebarHighlight;